<rt-dialog-header
  [heading]="'app.requisitions.approval_request_dialog.heading' | translate"
  [subheading]="'app.requisitions.approval_request_dialog.subheading_flow_preview' | translate"
  ><span class="step">{{
    'app.requisitions.approval_request_dialog.step_1' | translate
  }}</span></rt-dialog-header
>
<rt-dialog-body layout-vertical>
  <rt-heading variant="uppercased text-color" margin-bottom-small>
    @if (isDepartmentsMode) {
      {{ 'app.requisitions.approval_request_dialog.department' | translate }}:
      {{ departmentName ?? ('app.common.none' | translate) }}
      <rt-divider [variant]="'dot'"></rt-divider>
    }
    {{ 'app.requisitions.approval_request_dialog.flow' | translate }}: {{ flow.title }}
    <rt-badge color="counter-default" [text]="flow.steps.length" margin-left-small-x></rt-badge
  ></rt-heading>

  <rt-box layout-vertical>
    <rt-requisitions-flow-steps-list-container
      [steps]="flow.steps"
      [users]="adminsMap"
      [context]="flowViewContext"
    ></rt-requisitions-flow-steps-list-container>
  </rt-box>
</rt-dialog-body>
<rt-dialog-footer>
  <rt-button (click)="cancel.emit()" variant="plain">{{
    'app.common.cancel' | translate
  }}</rt-button>
  <rt-button (click)="continue.emit()" variant="primary"
    >{{ 'app.common.continue' | translate }}
    <rt-icon [name]="'keyboard-arrow-right'"></rt-icon>
  </rt-button>
</rt-dialog-footer>
